import classNames from "classnames"
import { FC, HTMLAttributes } from "react";

const PulseLoadingIndicator: FC<{ running?: boolean, className?:string, show?:boolean } & HTMLAttributes<HTMLDivElement>> = ({ show, running, className, ...props}) => {
  return (
     show && <div
      className={classNames("h-2 w-2 rounded-full opacity-0",className, running && "animate-ping! opacity-100!",)}
      {...props}
    />
  );
};

export default PulseLoadingIndicator;